import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../Button/Button";

export default function Navbar({
  loginButtonText,
  loginButtonGradient,
  signupButtonText,
  signupButtonGradient,
  signupTextColor,
  signupBorder,
  signupPadding,
  loginUrl,
  signupUrl,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Dynamic navigation data
  const navData = [
    {
      id: 123,
      title: "هاست",
      children: [
        {
          id: 1,
          type: "server",
          mainName: "دایرکت ادمین",
          name: "هاست اقتصادی",
          image: "/images/directadmin.png",
          slug: "economy-directadmin-hosting",
          secondName: "هاست دانلود",
          thirdName: "هاست پایتون",
          fourthName: "نمایندگی هاست",
          secondSlug: "download-hosting",
          thirdSlug: "python-hosting",
          fourthSlug: "directadmin-reseller-hosting",
        },
        {
          id: 2,
          type: "server",
          mainName: "سی پنل",
          name: "هاست اقتصادی",
          image: "/images/CPanel-PNG-Cutout.png",
          slug: "economy-cpanel-hosting",
          secondName: "هاست وردپرس",
          thirdName: "هاست ووکامرس",
          fourthName: "هاست ایمیل",
          fifthName: "نمایندگی هاست",
          secondSlug: "wordpress-hosting",
          thirdSlug: "woocommerce-hosting",
          fourthSlug: "mail-hosting",
          fifthSlug: "cpanel-reseller-hosting",
        },
        {
          id: 3,
          type: "server",
          mainName: "پلسک",
          name: "هاست اقتصادی",
          image: "/images/plesk.png",
          slug: "economy-plesk-hosting",
          secondName: "نمایندگی هاست",
          secondSlug: "plesk-reseller-hosting",
        },
      ],
    },
    {
      id: 124,
      title: "سرور ",
      children: [
        {
          id: 1,
          mainName: "سرور ها",
          image: "/images/database-storage.png",
          type: "server",
          name: "مجازی",
          secondName: "مجازی پیشرفته",
          thirdName: "اختصاصی",

          slug: "virtual-server",
          secondSlug: "advanced-virtual-server",
          thirdSlug: "iran-dedicated-server",
        },
        {
          id: 2,
          mainName: "سرویس های ابری",
          image: "/images/cloud-computing (2).png",
          type: "server",
          name: "OVH",
          secondName: "Hetzner",
          fourthName: "سرور ابری ایران",
          slug: "ovh-international-cloud-server",
          secondSlug: "hetzner-international-cloud-server",
          fourthSlug: "iran-cloud-server",
        },
      ],
    },
    {
      id: 125,
      title: "دامنه",
      children: [], // No children for دامنه
    },
    {
      id: 126,
      title: "خدمات",
      children: [
        {
          id: 1,
          mainName: "سرویس های ویژه",
          image: "/images/digital-services(1).png",
          type: "server",
          name: "Big Blue Button",
          secondName: "مودل",
          // thirdName: "گیت لب",
          fourthName: "ترید",
          fifthName: "طراحی سایت",
          sixthName: "گیت لب",
          seventhName: "سرویس پیامک انبوه",
          slug: "bigbluebutton-service",
          secondSlug: "advanced-moodle-services",
          // thirdSlug: "iran-gitlab-service",
          fourthSlug: "sroys-tryd",
          fifthSlug:
            "https://crm.spadserver.com/submitticket.php?step=2&deptid=8",
          sixthSlug: "gitlab-service",
          seventhSlug: "bulk-sms-system",
        },

        {
          id: 2,
          mainName: "خدمات اینترنتی",
          image: "/images/protection.png",
          type: "server",
          name: "سرویس بکاپ",
          secondName: "گواهینامه SSL",
          thirdName: "لایسنس",
          fourthName: "خدمات امنیت",
          fifthName: "سرویس مدیریت شده",
          slug: "backup-service",
          secondSlug: "ssl-certificate",
          thirdSlug: "licenses",
          fourthSlug: "security-services",
          fifthSlug: "managed-service"
        },
      ],
    },
    {
      id: 126,
      title: "پایگاه دانش",
      children: [
        {
          id: 125,
          title: "پایگاه دانش",
          children: [], // No children for دامنه
        },
      ],
    },
    {
      id: 126,
      title: "ارتباط با ما",
      children: [
        {
          id: 1,
          mainName: "ارتباط با ما",
          contactName: "ارتباط با ما",
          image: "/images/call-center.png",
          type: "server",
          name: "درباره ما",
          secondName: "مشتریان ما",
          thirdName: "ارسال تیکت",
          slug: "aboutus",
          secondSlug: "our-customers",
          thirdSlug: "https://Crm.spadserver.com/submitticket.php",
          contactSlug: "contact",
        },
      ],
    },
  ];

  const customSlugs = {
    دامنه: "domain",
    "درباره اسپاد": "aboutus",
    خدمات: "developers",
    "مشتریان ما": "our-customers",
    "ارتباط با ما": "contact",
    "پایگاه دانش": "https://spadserver.com/blog/",
  };

  const getLinkUrl = (slug) => {
    // List of slugs that should return a path
    const internalSlugs = [
      "domain",
      "aboutus",
      "our-customers",
      "contact",
      "developers",
    ];

    // Check if the slug is in the list of internal slugs
    if (internalSlugs.includes(slug)) {
      return `/${slug}`;
    }

    // If the slug is a valid URL, return it as is
    if (slug.startsWith("http://") || slug.startsWith("https://")) {
      return slug;
    }

    // Default case for product slugs
    return `/product/${slug}`;
  };

  return (
    <div className="flex flex-col md:flex-row font-main justify-between items-center p-3 text-md mx-4 md:mx-10 bg-custom-gradient mt-2 border-b-2 border-border">
      <a href="/">
        <div className="logo flex items-center">
          <img
            src="/images/spadLogo.png"
            className="w-24 h-18 mr-4"
            alt="Logo"
          />
        </div>
      </a>

      {/* Toggle button for mobile view */}
      <div className="block md:hidden">
        <button
          className="text-white focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>

      {/* Desktop and mobile menu */}
      <div
        className={`${
          isMenuOpen ? "block" : "hidden"
        } md:flex items-center text-white font-semibold w-full md:w-auto md:space-x-4`}
      >
        {navData.map((menu, index) => {
          const slug = customSlugs[menu.title] || "";
          const navbarHeight = menu.title.trim() === "سرور" ? "27px" : "auto";

          return (
            <div
              key={index}
              className="relative group"
              style={{ height: navbarHeight }} // Set height based on title
            >
              {menu.thirdName === "ارسال تیکت" ? (
                <a
                  href="https://Crm.spadserver.com/submitticket.php"
                  className="hostLink mx-4 md:mx-6 hover:text-blue-400 cursor-pointer"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {menu.thirdName} {/* Display thirdName */}
                </a>
              ) : (
                <Link
                  to={
                    menu.title === "پایگاه دانش"
                      ? "https://spadserver.com/blog/"
                      : menu.title === "دامنه"
                      ? `/${slug}` // Using slug for دامنه
                      : "#" // Default link if no specific case
                  }
                  className="hostLink mx-4 md:mx-6 hover:text-blue-400 cursor-pointer"
                  onClick={
                    menu.title === "دامنه" || menu.title === "پایگاه دانش"
                      ? undefined // Do not toggle menu for these titles
                      : () => setIsMenuOpen(!isMenuOpen) // Toggle menu for other titles
                  }
                >
                  {menu.title} {/* Display the menu title */}
                </Link>
              )}
              {menu.children.length > 0 &&
                menu.title !== "پایگاه دانش" &&
                menu.title !== "دامنه" && (
                  <div
                    className={`navbarSubMenu absolute top-full md:top-12 right-0 w-[300px] md:w-[480px] border-inset z-50 bg-white shadow-lg ${
                      isMenuOpen ? "block" : "hidden"
                    }`}
                  >
                    <div
                      className={`grid grid-cols-1 ${
                        menu.children.length > 3
                          ? "sm:grid-cols-3"
                          : menu.children.length > 1
                          ? "sm:grid-cols-2"
                          : "sm:grid-cols-2"
                      } px-5 py-0`}
                    >
                      {menu.children.map((subItem, subIndex) => ( //this is the main section to edit the submenu for (khadamar section in our primary nav)
                        <div
                          className="ggg pb-0 border-b-[1px] border-gray-400"
                          key={subIndex}
                        >
                          <ul className="mt-2 px-[12px] pb-2">
                            <li className="mt-1">
                              <div className="flex items-center p-2 border-b-[1px] border-gray-400">
                                {subItem.image && (
                                  <img
                                    alt={subItem.name}
                                    src={subItem.image}
                                    className="w-4 h-4 ml-2"
                                  />
                                )}
                                <span className="text-[12px] text-black font-normal opacity-100">
                                  {subItem.mainName}
                                </span>
                              </div>
                              <Link
                                to={getLinkUrl(subItem.slug)}
                                className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                              >
                                {subItem.name}
                              </Link>
                              {subItem.contactSlug && (
                                <Link
                                  to={getLinkUrl(subItem.contactSlug)}
                                  className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                                >
                                  {subItem.contactName}
                                </Link>
                              )}
                              {subItem.secondName && (
                                <Link
                                  to={getLinkUrl(subItem.secondSlug)}
                                  className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                                >
                                  {subItem.secondName}
                                </Link>
                              )}
                              {subItem.thirdName && (
                                <Link
                                  to={getLinkUrl(subItem.thirdSlug)}
                                  className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                                >
                                  {subItem.thirdName}
                                </Link>
                              )}
                              {subItem.fourthName && (
                                <Link
                                  to={getLinkUrl(subItem.fourthSlug)}
                                  className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                                >
                                  {subItem.fourthName}
                                </Link>
                              )}
                              {subItem.fifthName && (
                                <Link
                                  to={getLinkUrl(subItem.fifthSlug)}
                                  className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                                >
                                  {subItem.fifthName}
                                </Link>
                              )}
                              {subItem.sixthName && (
                                <Link
                                  to={getLinkUrl(subItem.sixthSlug)}
                                  className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                                >
                                  {subItem.sixthName}
                                </Link>
                              )}
                              {subItem.seventhName && ( //this code is for the submenu which is located at the navbar and its for the (khadamar section which has the services we provide.)
                                <Link
                                  to={getLinkUrl(subItem.seventhSlug)}
                                  className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
                                >
                                  {subItem.seventhName}
                                </Link>
                              )}
                            </li>
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
            </div>
          );
        })}
      </div>

      {/* Buttons for desktop */}
      <div className="hidden md:flex">
        <div className="flex space-x-4">
          <div className="loginButton ml-2">
            <a href={loginUrl}>
              <Button text={loginButtonText} gradient={loginButtonGradient} />
            </a>
          </div>
          <div className="signupButton">
            <a href={signupUrl}>
              <Button
                text={signupButtonText}
                gradient={signupButtonGradient}
                textColor={signupTextColor}
                border={signupBorder}
                padding={signupPadding}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import Button from "../Button/Button";

// export default function Navbar({
//   loginButtonText,
//   loginButtonGradient,
//   signupButtonText,
//   signupButtonGradient,
//   signupTextColor,
//   signupBorder,
//   signupPadding,
//   loginUrl,
//   signupUrl,
// }) {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   // Dynamic navigation data
//   const navData = [
//     {
//       id: 123,
//       title: "هاست",
//       children: [
//         {
//           id: 1,
//           type: "server",
//           mainName: "دایرکت ادمین",
//           name: "هاست کم حجم",
//           image: "/images/directadmin.png",
//           slug: "iran-web-hosting",
//           secondName: "هاست پر حجم",
//           secondSlug: "iran-web-hosting-pro",
//         },
//         {
//           id: 2,
//           type: "server",
//           mainName: "سی پنل",
//           name: "هاست کم حجم",
//           image: "/images/CPanel-PNG-Cutout.png",
//           slug: "iran-web-hosting-cpanel",
//           secondName: "هاست پر حجم",
//           secondSlug: "iran-web-hosting-pro-cpanel",
//         },
//         {
//           id: 3,
//           type: "server",
//           mainName: "پلسک",
//           name: "هاست کم حجم",
//           image: "/images/plesk.png",
//           slug: "iran-web-hosting-low-pleskk",
//           secondName: "هاست پر حجم",
//           secondSlug: "iran-web-hosting-pro-pleskk",
//         },
//         {
//           id: 4,
//           type: "server",
//           mainName: "نمایندگی هاست",
//           name: "هاست کم حجم",
//           image: "/images/branch.png",
//           slug: "host-reseller-directadmin-ir",
//         },
//       ],
//     },
//     {
//       id: 124,
//       title: "سرور",
//       children: [
//         {
//           id: 1,
//           mainName: "سرور ها",
//           image: "/images/database-storage.png",
//           type: "server",
//           name: "مجازی",
//           secondName: "نیمه اختصاصی",
//           thirdName: "اختصاصی",
//           slug: "iran-virtual-server",
//           secondSlug: "iran-semi-dedicated-server",
//           thirdSlug: "iran-dedicated-server",
//         },
//         {
//           id: 1,
//           mainName: "سرویس های ابری",
//           image: "/images/cloud-computing (2).png",
//           type: "server",
//           name: "OVH",
//           secondName: "Hetzner",
//           slug: "iran-web-hosting-pro",
//           secondSlug: "iran-virtual-server",
//         },
//       ],
//     },
//     {
//       id: 125,
//       title: "دامنه",
//       children: [], // No children for دامنه
//     },
//     {
//       id: 124,
//       title: "خدمات",
//       children: [
//         {
//           id: 1,
//           mainName: "سرویس های ویژه",
//           image: "/images/database-storage.png",
//           type: "server",
//           name: "Big Blue Button",
//           secondName: "مودل",
//           thirdName: "گیت لب",
//           fourthName:"ترید",
//           fifthName:"طراحی سایت",
//           slug: "iran-virtual-server",
//           secondSlug: "iran-semi-dedicated-server",
//           thirdSlug: "iran-dedicated-server",
//           fourthSlug: "iran-dedicated-server",
//           fifthSlug: "iran-dedicated-server",
//         },
//         {
//           id: 1,
//           mainName: "خدمات اینترنتی",
//           image: "/images/protection.png",
//           type: "server",
//           name: "سرویس بکاپ",
//           secondName: "گواهینامه SSL",
//           thirdName: "لایسنس",
//           slug: "iran-virtual-server",
//           secondSlug: "ssl-certificate",
//           thirdSlug: "licenses",
//         },
//       ],
//     },
//   ];

//   const customSlugs = {
//     دامنه: "domain",
//     "درباره اسپاد": "aboutus",
//     خدمات: "developers",
//     "مشتریان ما": "our-customers",
//     "ارتباط با ما": "contact",
//   };

//   const getLinkUrl = (slug) => {
//     return [
//       "domain",
//       "aboutus",
//       "our-customers",
//       "contact",
//       "developers",
//     ].includes(slug)
//       ? `/${slug}`
//       : `/product/${slug}`;
//   };

//   return (
//     <div className="flex flex-col md:flex-row font-main justify-between items-center p-3 text-md mx-4 md:mx-10 bg-custom-gradient mt-2 border-b-2 border-border">
//       <a href="/">
//         <div className="logo flex items-center">
//           <img
//             src="/images/spadLogo.png"
//             className="w-24 h-18 mr-4"
//             alt="Logo"
//           />
//         </div>
//       </a>

//       {/* Toggle button for mobile view */}
//       <div className="block md:hidden">
//         <button
//           className="text-white focus:outline-none"
//           onClick={() => setIsMenuOpen(!isMenuOpen)}
//         >
//           <svg
//             className="w-6 h-6"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M4 6h16M4 12h16m-7 6h7"
//             />
//           </svg>
//         </button>
//       </div>

//       {/* Desktop and mobile menu */}
//       <div
//         className={`${
//           isMenuOpen ? "block" : "hidden"
//         } md:flex items-center text-white font-semibold w-full md:w-auto md:space-x-4`}
//       >
//         {navData.map((menu, index) => {
//           const slug = customSlugs[menu.title] || "";

//           return (
//             <div key={index} className="relative group cursor-pointer">
//               <Link
//                 to={menu.title === "دامنه" ? `/${slug}` : "#"}
//                 className="hostLink mx-4 md:mx-6 hover:text-blue-400 cursor-pointer"
//                 onClick={
//                   menu.title === "دامنه"
//                     ? undefined
//                     : () => setIsMenuOpen(!isMenuOpen)
//                 }
//               >
//                 {menu.title}
//               </Link>

//               {/* No submenu for دامنه */}
//               {menu.children.length > 0 && menu.title !== "دامنه" && (
//                 <div className="navbarSubMenu hover:{main-title}:text-blue-400 absolute top-full md:top-12 right-0 w-[300px] md:w-[500px] border-inset  z-50 bg-white hidden group-hover:block shadow-lg">
//                   <div className="grid grid-cols-1 sm:grid-cols-3 px-5 py-0">
//                     {menu.children.map((subItem, subIndex) => (
//                       <div
//                         className="ggg pb-0 border-b-[1px] border-gray-400"
//                         key={subIndex}
//                       >
//                         <ul className="mt-2 px-[12px] pb-2">
//                           <li className="mt-1">
//                             <div className="flex items-center p-2 border-b-[1px] border-gray-400">
//                               {subItem.image && (
//                                 <img
//                                   alt={subItem.name}
//                                   src={subItem.image}
//                                   className="w-4 h-4 ml-2"
//                                 />
//                               )}
//                               <span className="text-[12px] text-black font-normal opacity-100">
//                                 {subItem.mainName}
//                               </span>
//                               {""}
//                               {/* Display mainName here */}
//                             </div>
//                             <Link
//                               to={getLinkUrl(subItem.slug)}
//                               className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
//                             >
//                               {subItem.name}
//                             </Link>
//                             {subItem.secondName && (
//                               <Link
//                                 to={getLinkUrl(subItem.secondSlug)}
//                                 className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
//                               >
//                                 {subItem.secondName}
//                               </Link>
//                             )}
//                             {subItem.thirdName && (
//                               <Link
//                                 to={getLinkUrl(subItem.secondSlug)}
//                                 className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
//                               >
//                                 {subItem.thirdName}
//                               </Link>
//                             )}
//                             {subItem.fourthName && (
//                               <Link
//                                 to={getLinkUrl(subItem.secondSlug)}
//                                 className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
//                               >
//                                 {subItem.fourthName}
//                               </Link>
//                             )}
//                             {subItem.fifthName && (
//                               <Link
//                                 to={getLinkUrl(subItem.fifthName)}
//                                 className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
//                               >
//                                 {subItem.fifthName}
//                               </Link>
//                             )}
//                             {subItem.sixthName && (
//                               <Link
//                                 to={getLinkUrl(subItem.secondSlug)}
//                                 className="text-gray-700 text-[10px] hover:bg-blue-300 mt-2 font-medium px-2 py-1 rounded-md flex items-center"
//                               >
//                                 {subItem.sixthName}
//                               </Link>
//                             )}
//                           </li>
//                         </ul>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* Buttons for desktop */}
//       <div className="hidden md:flex">
//         <div className="flex space-x-4">
//           <div className="loginButton ml-2">
//             <a href={loginUrl}>
//               <Button text={loginButtonText} gradient={loginButtonGradient} />
//             </a>
//           </div>
//           <div className="signupButton">
//             <a href={signupUrl}>
//               <Button
//                 text={signupButtonText}
//                 gradient={signupButtonGradient}
//                 textColor={signupTextColor}
//                 border={signupBorder}
//                 padding={signupPadding}
//               />
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
